// extracted by mini-css-extract-plugin
export const root = "M_bz";
export const name = "M_cN";
export const size = "M_cP";
export const deleteBtn = "M_cQ";